import { Receipt } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { formatCurrency } from './utils'
import type { Expense } from './types'

interface ExpensesCardProps {
  expenses: Expense[]
}

export function ExpensesCard({ expenses }: ExpensesCardProps) {
  const totalExpenses = expenses.reduce((sum, e) => sum + e.amount_cents, 0)

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
        <Receipt className="h-5 w-5 text-slate-400" />
        Ausgaben
        <Badge variant="secondary" className="ml-auto">
          {expenses.length}
        </Badge>
      </h2>
      {expenses.length === 0 ? (
        <p className="text-slate-500 text-sm">Noch keine Ausgaben erfasst.</p>
      ) : (
        <>
          <div className="space-y-2 mb-4">
            {expenses.map((expense) => (
              <div
                key={expense.id}
                className="flex items-center justify-between p-2 bg-slate-50 rounded-lg"
              >
                <div>
                  <span className="text-sm font-medium text-slate-700">
                    {expense.expense_type_display}
                  </span>
                  {expense.description && (
                    <p className="text-xs text-slate-500 truncate max-w-[150px]">
                      {expense.description}
                    </p>
                  )}
                </div>
                <span className="text-sm font-medium text-slate-900">
                  {formatCurrency(expense.amount_cents, expense.currency)}
                </span>
              </div>
            ))}
          </div>
          <div className="border-t pt-3 flex items-center justify-between">
            <span className="font-medium text-slate-700">Gesamt</span>
            <span className="font-bold text-slate-900">
              {formatCurrency(totalExpenses, expenses[0]?.currency || 'EUR')}
            </span>
          </div>
        </>
      )}
    </div>
  )
}
